import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ConfigService } from '../../services/config.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
  templateUrl: './login.component.html',
  imports: [CommonModule, ReactiveFormsModule],
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  isLoading = false;
  errorMessage = '';
  discogsConnected = false;
  discogsError: string | null = null;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private configService: ConfigService
  ) {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
    this.discogsConnected = !!localStorage.getItem('discogs_token') && !!localStorage.getItem('discogs_tokenSecret');
  }

  ngOnInit(): void {
    window.addEventListener('message', (event) => {
      if (event.origin === environment.apiUrl) {
        if (event.data?.type === 'auth_success') {
          localStorage.setItem('discogs_token', event.data.token);
          localStorage.setItem('discogs_tokenSecret', event.data.tokenSecret);
          this.discogsConnected = true;
          this.isLoading = false;
        } else if (event.data?.type === 'auth_error') {
          this.discogsError = 'Error authenticating with Discogs';
          this.isLoading = false;
        }
      }
    });
  }

  openDiscogsRedirect() {
    this.isLoading = true;
    this.discogsError = null;
    fetch(`${environment.apiUrl}/auth/discogs`, {
      credentials: 'include'
    })
      .then(res => res.json())
      .then(data => {
        if (data.url) {
          window.location.href = data.url;
        } else {
          this.isLoading = false;
          this.discogsError = 'No authorization URL received from backend.';
        }
      })
      .catch(err => {
        this.isLoading = false;
        this.discogsError = 'Could not create authentication session.';
      });
  }

  disconnectDiscogs() {
    localStorage.removeItem('discogs_token');
    localStorage.removeItem('discogs_tokenSecret');
    this.discogsConnected = false;
  }

  loginWithOAuth(provider: 'google' | 'facebook' | 'spotify' | 'discogs'): void {
    if (provider === 'discogs') {
      this.openDiscogsRedirect();
    } else {
      this.authService.loginWithOAuth(provider);
    }
  }

  onSubmit(): void {
    if (this.loginForm.valid && !this.isLoading) {
      this.isLoading = true;
      this.errorMessage = '';
      this.authService.loginWithEmail(this.loginForm.value).subscribe({
        next: () => {
          this.router.navigate(['/dashboard']);
        },
        error: (error: any) => {
          this.isLoading = false;
          this.errorMessage = error.error?.message || 'Invalid credentials. Please try again.';
        }
      });
    }
  }

  get email() { return this.loginForm.get('email'); }
  get password() { return this.loginForm.get('password'); }
}
